import { ContactTopic } from "../Contact.model";
import { Document } from "@contentful/rich-text-types";

export enum FORM_FIELDS {
  "firstname" = "First Name",
  "lastname" = "Last Name",
  "jobtitle" = "Job Title",
  "company" = "Company",
  "email" = "Email",
  "message" = "Message",
}

export const generic_fields = [
  FORM_FIELDS.firstname,
  FORM_FIELDS.lastname,
  FORM_FIELDS.email,
  FORM_FIELDS.message,
];

export interface ContactFormPropsModel {
  topic?: ContactTopic;
  isLoading: boolean;
  error?: Document;
  handleSubmit: (data: FormData) => void;
}
